import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { ControlsModule } from 'segov-sigepo-lib';
import { SegovPage } from 'src/app/app.routes';
import { LinkClickable, SegovSigepoHeaderSectionComponent } from 'src/app/controls/segov-sigepo-header-section/segov-sigepo-header-section.component';
import { SegovSigepoPortalBodyComponent } from 'src/app/controls/segov-sigepo-portal-body/segov-sigepo-portal-body.component';
import { ComponentMessages } from 'src/app/utils/component.messages';
import { ObterBancoNoticiasState } from 'src/app/stateManagement/reducers/BancoNoticias/obter-banco-noticias.reducer';
import { Store } from '@ngrx/store';
import { filter, Subscription } from 'rxjs';
import { selectDadosObterBancoNoticias } from 'src/app/stateManagement/selectors/BancoNoticias/obter-banco-noticias.selector';
import { BancoNoticiasOutputDto } from 'src/app/domain/DTOs/output/banco-noticias.output.dto';
import { obterBancoNoticias, obterBancoNoticiasFinish } from 'src/app/stateManagement/actions/BancoNoticias/obter-banco-noticias.action';
import { ScreenUtils } from 'src/app/utils/screen.utils';
import { MenuItemReportagem, MenuReportagensComponent } from './sub-views/menu-reportagens/menu-reportagens.component';

@Component({
  selector: 'app-reportagens-iconicas',
  standalone: true,
  imports: [
    MenuReportagensComponent,
    SegovSigepoPortalBodyComponent,
    SegovSigepoHeaderSectionComponent,
    ControlsModule
  ],
  templateUrl: './reportagens-iconicas.component.html'
})
export class ReportagensIconicasComponent implements OnInit, OnDestroy {

  public title = ComponentMessages.conhecaODiario;
  public RouteStack: LinkClickable[] = [
    { title: "Início", route: SegovPage.Inicio },
    { title: "Sobre", route: SegovPage.HistoriaJornal },
    { title: "Reportagens Históricas", route: SegovPage.ReportagensIconicas }
  ];

  public menusReportagem: MenuItemReportagem[] = [];
  public pesquisouPrimeiraVez = false;
  public primeiraInicializacao = new EventEmitter<string>();
  private subObterBancoNoticias: Subscription;

  constructor(
    private readonly storeObterBancoNoticias: Store<{ obterBancoNoticias: ObterBancoNoticiasState }>,
  ) {
    this.subObterBancoNoticias = new Subscription();
  }

  ngOnInit(): void {
    this.subObterBancoNoticias = this.storeObterBancoNoticias.select(selectDadosObterBancoNoticias)
      .pipe(filter(state => state !== null))
      .subscribe(response => {
        if(response)
          this.menusReportagem = this.groupCategoriasParaMenuItems(response?.dados);
        if(!this.pesquisouPrimeiraVez){
          setTimeout(() => {
            this.primeiraInicializacao.emit(this.menusReportagem[0].topic);
          }, 50)
        }
        this.pesquisouPrimeiraVez = true;
      });

    this.getBancoNoticias();
  }

  ngOnDestroy(): void {
    this.subObterBancoNoticias.unsubscribe();
    this.storeObterBancoNoticias.dispatch(obterBancoNoticiasFinish());
  }

  public obterTopicoClicado(topico: string) {
    ScreenUtils.scrollToIdByResolution(topico, 993);
    this.getBancoNoticias(topico);
  }

  private getBancoNoticias(topico?: string) {
    this.storeObterBancoNoticias.dispatch(obterBancoNoticias({ inputDto: topico??''}));
  }

  private groupCategoriasParaMenuItems(
    dados: BancoNoticiasOutputDto[]
  ) {
    const menuItemsMap: Record<string, MenuItemReportagem> = {};

    dados.forEach(x => {
      if (!menuItemsMap[x.categoria]) {
        menuItemsMap[x.categoria] = {
          topic: x.categoria,
          reportagens: [{
            dataPublicacaoFormatada: x.dataPublicacaoFormatada,
            dataPublicacao: x.dataPublicacao,
            titulo: x.titulo,
            nomeArquivoPdf: x.nomeArquivoPdf,
            idJornal: x.idJornal,
            pagina: x.pagina
          }]
        }
      }
      else{
        menuItemsMap[x.categoria].reportagens.push({
          dataPublicacaoFormatada: x.dataPublicacaoFormatada,
          dataPublicacao: x.dataPublicacao,
          titulo: x.titulo,
          nomeArquivoPdf: x.nomeArquivoPdf,
          idJornal: x.idJornal,
          pagina: x.pagina
        });
      }
    });

    return Object.values(menuItemsMap);
  }
}